import { DrawingToolMenuItem } from './drawingToolMenu'
import OiProfile from '../../../../assets/icons/OiProfile'
import Chart from '../../../../assets/icons/Chart'

export const oiProfileMenuItems: DrawingToolMenuItem[] = [
    {
        drawingToolId: 'oiProfile',
        text: 'OI Profile',
        code: 'OI_PROFILE',
        icon: <OiProfile />,
        drawingType: 'oiProfile',
        toolOptions: {}
    },
    {
        drawingToolId: 'oiOutLook' as any,
        text: 'OI Outlook',
        code: 'OPEN_INTEREST_OUTLOOK',
        icon: <Chart />,
        drawingType: 'oiOutlook' as any,
        toolOptions: {}
    }
]